import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as ShowSvg } from '../icons/show.svg'
import classNames from "classnames";
import TnMessage from "@/global/components/message";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarContext } from "@/App";
import { CommonTabbarState } from "@/global/components/common-tabbar";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import { getSensorTypeName } from "@/enums/sensor-type";


interface Iprops {
    monitorParameter: MonitorParameter // 监测参数
    active: boolean, // 是否激活
}
export default function MonitorParameterItem(props: Iprops) {
    const { monitorParameter, active } = props
    const [item, setItem] = useState<MonitorParameter>();
    const itemRef = useRef(item);
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文

    useEffect(() => {
        setItem(monitorParameter);
        return (() => {
            emitter.off(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
        })
    }, [monitorParameter])

    useEffect(() => {
        itemRef.current = item
    }, [item])

    // 点击了展开收起
    const handleExpandItem = () => {
        setItem({ ...item, expanded: !item.expanded });
    }

    // 点击了监测对象，访问其详情
    const onClickMonitorObject = () => {
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_OBJECT}/${item.monitorObjectId}`)
    }

    // 访问监测参数详情
    const onOpenDetail = () => {
        setItem({ ...item, expanded: true });
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_PARAMETER}/${item.id}`)
        // 监听更新监测参数的信号
        emitter.on(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
    }

    // 更新了监测参数的详情
    const onUpdateMonitorParameterFinish = (result: MonitorParameter) => {
        if (result?.id != item.id) return;
        setItem({ ...itemRef.current, ...result, expanded: true });
    }

    // 打开传感器详情
    const onOpenSensorDetail = (sensorId: number, sensorType: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.DEVICE}/${sensorId}/sensor`)
    }

    if (!item) {
        return (<div></div>)
    }

    return (
        <div className="monitor-parameter-item">
            <div className={classNames({
                "title": true,
                "selected": active,
            })} onClick={handleExpandItem}>
                <div className="name" onClick={(e) => {
                    e.stopPropagation();
                    onOpenDetail();
                }}>
                    <span style={{ width: '22px' }}>{item.encoding}</span>
                    <span style={{ marginLeft: '8px' }}>{item.name}</span>
                    <span style={{ marginLeft: '8px' }}>{item.code}</span>
                    <ShowSvg className={classNames({
                        "arrow-icon": true,
                        "expanded": item.expanded
                    })} />
                </div>
                <div className="monitor-obj-name" onClick={(e) => {
                    e.stopPropagation();
                    onClickMonitorObject();
                }}>{item.monitorObjectName}</div>
            </div>
            {item.expanded && (
                <div className="param-list">
                    {(item.subParametersDq || []).map((param, idx) => (
                        <div key={idx} className="param">
                            <div className="param-name">{item.encoding}-{param.location}<span style={{ marginLeft: '8px' }}>{param.name}{param.code}</span></div>
                            {!param.sensorId && param.sensorType && <div className="sensor-type-btn"><div className="text">{getSensorTypeName(param.sensorType)}</div></div>}
                            {param.sensorId && <div className="sensor-btn" onClick={() => onOpenSensorDetail(param.sensorId, param.sensorType)}><div className="text ellipsis">{param.sensorCode}</div></div>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}